export * from "ce/constants/approvedErrorMessages";
import { APPROVED_ERROR_MESSAGES as APPROVED_ERROR_MESSAGES_CE } from "ce/constants/approvedErrorMessages";
import { createMessage, DEFAULT_ERROR_MESSAGE } from "./messages";
import {
  SAML_ALREADY_CONFIGURED,
  UNABLE_TO_FIND_SAML_CONFIGURATION,
  INVALID_SESSION_AUTH_REQUEST_NOT_FOUND,
  INVALID_SESSION_REGISTRATION_ID_NOT_FOUND,
  INVALID_AUTHORIZATION_TOKEN,
  INVALID_API_KEY,
  API_KEY_NOT_MAPPED,
  API_KEY_ALREADY_EXISTS,
  SEATS_UNAVAILABLE,
} from "./messages";

export const APPROVED_ERROR_MESSAGES = {
  static: [
    ...APPROVED_ERROR_MESSAGES_CE.static,
    SAML_ALREADY_CONFIGURED,
    UNABLE_TO_FIND_SAML_CONFIGURATION,
    INVALID_SESSION_AUTH_REQUEST_NOT_FOUND,
    INVALID_SESSION_REGISTRATION_ID_NOT_FOUND,
    INVALID_AUTHORIZATION_TOKEN,
    INVALID_API_KEY,
    API_KEY_NOT_MAPPED,
    API_KEY_ALREADY_EXISTS,
    SEATS_UNAVAILABLE,
  ],
  patterns: [
    ...APPROVED_ERROR_MESSAGES_CE.patterns,
    /^SAML configuration failed\. [a-zA-Z0-9\s.,_\-:()'"]+$/,
    /^Login with [a-zA-Z0-9\s\.-]+ is not supported\.$/,
  ],
};

/**
 * Checks if an error message is in the approved list
 * @param message The error message to validate
 * @returns boolean indicating if message is approved
 */
export function isApprovedErrorMessage(message: string): boolean {
  // First check static messages
  if (
    APPROVED_ERROR_MESSAGES.static.some((msg) =>
      typeof msg === "function" ? msg() === message : msg === message,
    )
  ) {
    return true;
  }

  // Then check regex patterns
  return APPROVED_ERROR_MESSAGES.patterns.some((pattern) =>
    pattern.test(message),
  );
}

/**
 * Returns either the approved message or a default error message
 * @param message The error message to validate
 * @returns The original message if approved, or a default message
 */
export function getSafeErrorMessage(message: string): string {
  const isApproved = isApprovedErrorMessage(message);

  if (!isApproved) {
    return createMessage(DEFAULT_ERROR_MESSAGE);
  }

  // If it's a static message, find and return it wrapped in createMessage
  const staticMessage = APPROVED_ERROR_MESSAGES.static.find((msg) =>
    typeof msg === "function" ? msg() === message : msg === message,
  );

  if (staticMessage) {
    return typeof staticMessage === "function"
      ? createMessage(staticMessage)
      : staticMessage;
  }

  // For pattern matches, return the original message wrapped in createMessage
  return createMessage(() => message);
}
